import React from 'react';

import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { PDFViewerWebInstance } from '@bcp-nextgen-dx-component-factory/design-system';
import { useDrawer } from '@hooks';

interface PdfViewDrawerHelperInput {
	drawerUniqueName: string;
}

interface PdfViewDrawerHelperResources {
	confirmReadAndAccepted: string;
	confirmAndAccepted: string;
	scrollToReadAndAccept: string;
	gotIt: string;
}

interface PdfViewDrawerHelperOutput {
	resources: PdfViewDrawerHelperResources;
	drawerTopDistance: number;
	ref: React.RefObject<PDFViewerWebInstance>;
	pdfViewerHeight: number;
	scrolled: boolean;
	onScrolled: () => void;
	hidePdfDrawer: () => void;
}

export const usePdfViewerDrawerHelper = ({ drawerUniqueName }: PdfViewDrawerHelperInput): PdfViewDrawerHelperOutput => {
	const t = useTranslation();
	const { hide: hidePdfDrawer } = useDrawer(drawerUniqueName);
	const ref = React.useRef<PDFViewerWebInstance>(null);
	const drawerTopDistance = 55;
	const pdfViewerHeight = window.innerHeight - drawerTopDistance;
	const [scrolled, setScrolled] = React.useState(false);

	const resources: PdfViewDrawerHelperResources = {
		confirmReadAndAccepted: t('general.pdfViewer.footer.descriptions.confirmReadAndAccepted'),
		confirmAndAccepted: t('general.pdfViewer.footer.actions.confirmAndAccepted'),
		scrollToReadAndAccept: t('general.pdfViewer.walkthroughOverlay.descriptions.scrollToReadAndAccept'),
		gotIt: t('general.pdfViewer.walkthroughOverlay.actions.gotIt'),
	};

	const onScrolled = () => {
		setScrolled(true);
	};

	return { resources, drawerTopDistance, ref, pdfViewerHeight, scrolled, onScrolled, hidePdfDrawer };
};
